import { Component, ChangeDetectionStrategy, computed, inject, input } from "@angular/core";
import { RouterModule } from "@angular/router";
import { toSignal } from "@angular/core/rxjs-interop";
import { Store } from "@ngrx/store";
import { TranslateModule } from "@ngx-translate/core";
import { TooltipModule } from "primeng/tooltip";
import { RippleModule } from "primeng/ripple";

import { UserContext } from "src/app/store/user/user.state";
import { selectContractId, selectContractName } from "src/app/store/pages/contract/contract.selectors";
import { NavRoutesService } from "src/app/navigation/nav-routes.service";
import { NavContextHeaderComponent } from "../../parts/nav-context-header/nav-context-header.component";

@Component({
    selector: "app-contract-view",
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [RouterModule, TranslateModule, TooltipModule, RippleModule, NavContextHeaderComponent],
    templateUrl: "./contract-view.component.html",
    styleUrl: "./contract-view.component.scss",
})
export class ContractViewComponent {

    // =========================================================================
    // DEPENDENCY INJECTION
    // =========================================================================
    private readonly store = inject(Store);
    private readonly navRoutes = inject(NavRoutesService);

    // =========================================================================
    // INPUTS
    // =========================================================================
    public readonly expanded = input.required<boolean>();
    public readonly user = input.required<UserContext | null>();

    // =========================================================================
    // STORE SIGNALS
    // =========================================================================
    private readonly contractId = toSignal(this.store.select(selectContractId), { initialValue: null });
    private readonly contractName = toSignal(this.store.select(selectContractName), { initialValue: null });

    // =========================================================================
    // COMPUTED - Routes
    // =========================================================================
    public readonly overviewRoute = computed(() => this.tabRoute("overview"));
    public readonly discountsRoute = computed(() => this.tabRoute("discount"));

    // =========================================================================
    // COMPUTED - Header
    // =========================================================================
    public readonly contractsListRoute = computed(() => this.navRoutes.route("contract"));
    public readonly headerTitle = computed(() => this.contractName() ?? "");
    public readonly headerLoading = computed(() => !this.contractName());

    // =========================================================================
    // PRIVATE METHODS
    // =========================================================================
    private tabRoute(tab: string): string[] | null {
        const id = this.contractId();
        return id ? this.navRoutes.route("contract", id, tab) : null;
    }
}
